import clsx from "clsx";

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
  as?: any;              // "a" | Link | button
  href?: string;
  className?: string;
  disabled?: boolean;
  size?: "md" | "lg";
};

export default function GlowButton({
  children, onClick, as, href, className, disabled, size = "md",
}: Props) {
  const Comp: any = as ?? "button";
  const pad = size === "lg" ? "h-12 px-5 text-[15px]" : "h-10 px-4 text-sm";

  return (
    <Comp
      href={href}
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        "relative inline-flex items-center justify-center rounded-2xl",
        "transition shadow-[0_6px_30px_rgba(168,85,247,.18)]",
        "active:scale-[.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-fuchsia-400/70",
        "border border-white/10",
        pad,
        // фон + градиент
        "bg-gradient-to-r from-fuchsia-500 via-violet-500 to-emerald-500",
        // стеклянная пелена поверх, чтобы текст было видно всегда
        "before:absolute before:inset-[1px] before:rounded-[14px] before:bg-zinc-900/70 before:backdrop-blur",
        // тонкое внешнее свечение
        "after:pointer-events-none after:absolute after:-inset-0.5 after:rounded-[18px] after:bg-gradient-to-r after:from-fuchsia-500/40 after:to-emerald-500/40 after:opacity-40",
        "hover:after:opacity-70",
        disabled && "opacity-60 pointer-events-none",
        className
      )}
    >
      <span className="relative z-10 font-medium text-white">{children}</span>
    </Comp>
  );
}
